import { render, staticRenderFns } from "./Expirations.vue?vue&type=template&id=a017b2de"
import script from "./Expirations.vue?vue&type=script&lang=js"
export * from "./Expirations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports